import { PermissionCode } from '@gb-ticket/shared-types';
import { useSearchParams } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { useIntranetCategories } from '@/products/intranet/features/intranet/use-intranet';
import {
  INTRANET_CHANNEL_COMPOSE_PATH,
  intranetChannelComposePath,
} from '@/products/intranet/intranet-paths';

/** Composer link for the intranet feed / FAB — shared by the home page and layout chrome. */
export function useIntranetHomeWriteHref(): string | null {
  const me = useMe();
  const categories = useIntranetCategories();
  const [params] = useSearchParams();
  const activeSlug = params.get('category');
  const category = categories.data?.items.find((item) => item.slug === activeSlug);
  const canWrite = hasPermission(me.data, PermissionCode.INTRANET_CONTENT_WRITE);
  const postableCategories = (categories.data?.items ?? []).filter((item) => item.canPost);

  if (canWrite) {
    return INTRANET_CHANNEL_COMPOSE_PATH;
  }
  if (category?.canPost) {
    return intranetChannelComposePath(category.id);
  }
  if (postableCategories.length > 0) {
    return intranetChannelComposePath();
  }
  return null;
}
